import React from 'react';
import { IconProps } from './types';

export const CoinIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path
      d="M9.5 8C9.5 8 10.5 7.5 12 7.5C13.5 7.5 14.5 8 14.5 8V16C14.5 16 13.5 16.5 12 16.5C10.5 16.5 9.5 16 9.5 16V8Z"
      fill="currentColor"
    />
    <path
      d="M12 16.5V20M12 4V7.5M8 10H16M8 14H16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
